import {
  PagedResponse,
  PatchWithMeta,
  QueryParams,
  ValidatedResponse,
} from "@ofqual/portal-core/core/types";
import {
  all,
  call,
  getContext,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { MODULE_NAME } from "../moduleName";
import { commissionsService } from "../services";
import {
  ActionPayload,
  CREATED_ITEM,
  CREATING_ITEM,
  CREATING_ITEM_VALIDATION_FAIL,
  loadedItem,
  loadedItems,
  LOADING_ITEM,
  LOADING_ITEMS,
  savedItem,
  PATCHING_ITEM,
  PATCHING_ITEM_VALIDATION_FAIL,
} from "./actions";
import { authSelector } from "./selectors";
import { History } from "history";
import { CommissionModel } from "../domain/CommissionModel";
function* navigate(url: string) {
  const history: History = yield getContext("history");
  yield call(() => history.push(url));
}

function* watchItemsSaga() {
  yield takeLatest(LOADING_ITEMS, itemsSaga);
}

function* watchItemSaga() {
  yield takeLatest(LOADING_ITEM, itemSaga);
}

function* watchUpdateItemSaga() {
  yield takeEvery(PATCHING_ITEM, patchItemSaga);
}
function* watchCreateItemSaga() {
  yield takeEvery(CREATING_ITEM, createItemSaga);
}

function* itemsSaga({ payload }: ActionPayload<QueryParams>) {
  const auth: ReturnType<typeof authSelector> = yield select(authSelector);

  const items: PagedResponse<CommissionModel> = yield call(
    [commissionsService, commissionsService.search],
    { ...payload },
    { token: auth.token }
  );
  yield put(loadedItems(items));
}

function* itemSaga({ payload }: ActionPayload<string>) {
  const auth: ReturnType<typeof authSelector> = yield select(authSelector);

  const item: CommissionModel = yield call(
    [commissionsService, commissionsService.get],
    payload,
    {
      token: auth.token,
    }
  );
  yield put(loadedItem(item));
}

function* patchItemSaga({ payload }: ActionPayload<any>) {
  const auth: ReturnType<typeof authSelector> = yield select(authSelector);

  const { id, patchDocument } = payload as {
    id: string;
    patchDocument: PatchWithMeta<CommissionModel>;
  };

  const validatedResponse: ValidatedResponse<CommissionModel> = yield call(
    [commissionsService, commissionsService.patch],
    id,
    patchDocument,
    {
      token: auth.token,
    }
  );

  if (validatedResponse.isValid) {
    yield put(savedItem(validatedResponse.data));
  } else {
    yield put({
      type: PATCHING_ITEM_VALIDATION_FAIL,
      payload: validatedResponse.error,
    });
  }
}

function* createItemSaga({ payload }: ActionPayload<CommissionModel>) {
  const auth: ReturnType<typeof authSelector> = yield select(authSelector);

  const validatedResponse: ValidatedResponse<CommissionModel> = yield call(
    [commissionsService, commissionsService.create],
    payload,
    {
      token: auth.token,
    }
  );
  if (validatedResponse.isValid) {
    yield put({ type: CREATED_ITEM });
    yield call(() => navigate(`/${MODULE_NAME}/${validatedResponse.data.id}`));
  } else {
    yield put({
      type: CREATING_ITEM_VALIDATION_FAIL,
      payload: validatedResponse.error,
    });
  }
}

export function* rootSaga() {
  yield all([
    watchItemsSaga(),
    watchItemSaga(),
    watchUpdateItemSaga(),
    watchCreateItemSaga(),
    // further sagas...
  ]);
}
